import React from "react";
import { GameflowObjects } from "./GameFlowObjects";
import Lines from "./Lines";
import MobileBg from "../../svgs/gameflow/MobileBg";

export default function GameflowLayout() {
  return (
    <div>
      <div className=" w-full text-center text-4xl lg:text-6xl font-Red-Undead uppercase text-white pt-28 lg:pt-48">
        Game Flow
      </div>
      <div className="overflow-hidden mt-20 lg:mt-32  relative h-[1200px] lg:h-[1600px]">
        <div className="absolute right-0   left-0 mx-auto max-w-[1000px] lg:pt-0 pt-8">
          <span className="lg:block hidden">
            <Lines />
          </span>
          <div className="absolute -z-10 top-20 -translate-x-1/2 left-1/2 lg:hidden">
            <MobileBg />
          </div>
          {GameflowObjects.map((div, index) => (
            <div
              key={index}
              className={`relative z-10 flex flex-col justify-start mb-20 items-center text-white font-Helvetica text-3xl font-bold
              ${index === 3 ? "lg:mb-20" : "lg:mb-14"}`}
            >
              <div className="lg:scale-100 hidden lg:block ">
                {div.icon}
              </div>
              <div className="lg:hidden ">
                <img src={div.mobileIcon} alt="" />
              </div>
              <div className="lg:my-0 my-4 lg:text-3xl text-lg ">{div.title}</div>
              <div className={`lg:mt-6 mt-0 text-xs lg:text-lg font-normal text-center
              lg:w-full ${index === 0 || index === 2 ? 'w-[220px]' : 'w-[300px]'}
              `}>
                {div.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
